<template>
  <div>
    <NavbarView :rainbow="false" />

    <h1>GEOGRAPHICAL DATA</h1>

    <button class="back-button" @click="$router.back()">
      ← Back
    </button>

    <!-- GLOBE DATA -->
    <section>
      <h2>Globe data (3D)</h2>
      <ul>
        <li v-for="item in globeData" :key="item.url">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            {{ item.label }}
          </a>
        </li>
      </ul>
    </section>

    <!-- WEB MERCATOR DATA -->
    <section>
      <h2>WebMercator (2D)</h2>
      <ul>
        <li v-for="item in webMercatorData" :key="item.url">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            {{ item.label }}
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import NavbarView from '../../NavbarView.vue';

export default {
  name: 'GeographicalDataView',
  components: { NavbarView },

  data() {
    return {
      globeData: [
        {
          label: 'geoBoundaries – level 0',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/Globe/geoBoundaries0.zip',
        },
        {
          label: 'geoBoundaries – level 1',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/Globe/geoBoundaries1.zip',
        },
      ],

      webMercatorData: [
        {
          label: 'geoBoundaries – level 0',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/geoBoundaries0.zip',
        },
        {
          label: 'geoBoundaries – level 1',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/geoBoundaries1.zip',
        },
        {
          label: 'geoBoundaries – level 2',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/geoBoundaries2.zip',
        },
        {
          label: 'NUTS – level 0',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts0.zip',
        },
        {
          label: 'NUTS – level 1',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts1.zip',
        },
        {
          label: 'NUTS – level 2',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts2.zip',
        },
        {
          label: 'NUTS – level 3',
          url: 'https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts3.zip',
        },
      ],
    };
  },
};
</script>

<style scoped>

.back-button {
  position: fixed;
  top: 90px;
  left: 30px;
  background: #eee;
  border: none;
  color: #333;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  z-index: 10;
}

.back-button:hover {
  background: #ddd;
}

h1 {
  text-align: center;
  margin: 100px 0 30px;
  font-size: 2.5em;
  color: #176219;
}
</style>

<!-- 
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/Globe/geoBoundaries0.zip
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/Globe/geoBoundaries1.zip

https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/geoBoundaries0.zip
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/geoBoundaries1.zip
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/geoBoundaries2.zip

https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts0.zip
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts1.zip
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts2.zip
https://f003.backblazeb2.com/file/touchdesigner-geographical-data/Mesh/WebMercator/nuts3.zip
-->